export function sortByIndex(
  entries: [string, { index?: number | undefined } | undefined][]
) {
  entries.sort((a, b) => {
    const ai = a[1]?.index || 0;
    const bi = b[1]?.index || 0;
    return ai - bi;
  });
}
